import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card border-0 rounded-3 bg-white position-relative z-1 mb-4 p-25" }
const _hoisted_2 = { class: "default-table-area style-two upcoming-vip-reservations-table" }
const _hoisted_3 = { class: "table-responsive" }
const _hoisted_4 = { class: "table align-middle border-0" }
const _hoisted_5 = { class: "fs-12 fw-semibold text-body" }
const _hoisted_6 = { class: "fs-12 fw-semibold text-body-color-50" }
const _hoisted_7 = {
  class: "bg-border-color-50 fs-12 fw-medium text-primary d-inline-block rounded-1",
  style: {"padding":"3px 8px"}
}
const _hoisted_8 = { class: "d-flex justify-content-center justify-content-sm-between align-items-center text-center flex-wrap gap-2 showing-wrap mt-10" }
const _hoisted_9 = { class: "fs-12 fw-medium" }
const _hoisted_10 = { "aria-label": "Page navigation" }
const _hoisted_11 = { class: "pagination mb-0 justify-content-center" }
const _hoisted_12 = ["onClick"]

import { ref, computed } from "vue";

interface Reservation {
  code: string;
  room: string;
  customer: string;
  duration: string;
}

const itemsPerPage = 5;


export default /*@__PURE__*/_defineComponent({
  __name: 'UpcomingVIPReservations',
  setup(__props) {

const reservations = ref<Reservation[]>([
  {
    code: "TRZ-32",
    room: "Duluxe Room - G - 3215",
    customer: "Angela Carter",
    duration: "10 Dec - 15 Dec",
  },
  {
    code: "TRZ-34",
    room: "Sweet Suite - S - 1265",
    customer: "Walter White",
    duration: "12 Dec - 16 Dec",
  },
  {
    code: "TRZ-42",
    room: "The Queensland - Q32",
    customer: "Zennifer Loren",
    duration: "15 Dec - 20 Dec",
  },
  {
    code: "TRZ-15",
    room: "Sweet Suite - S - 3214",
    customer: "Johna Mandala",
    duration: "11 Dec - 14 Dec",
  },
  {
    code: "TRZ-29",
    room: "Duluxe Room - F - 7213",
    customer: "Viktor James",
    duration: "10 Dec - 15 Dec",
  },
  {
    code: "TRZ-55",
    room: "Presidential Suite - P - 9000",
    customer: "Bruce Wayne",
    duration: "20 Dec - 25 Dec",
  },
  {
    code: "TRZ-61",
    room: "Garden View - G - 3301",
    customer: "Clark Kent",
    duration: "13 Dec - 17 Dec",
  },
]);

const currentPage = ref(1);
const totalPages = computed(() =>
  Math.ceil(reservations.value.length / itemsPerPage)
);

const paginatedData = computed(() => {
  const start = (currentPage.value - 1) * itemsPerPage;
  return reservations.value.slice(start, start + itemsPerPage);
});

function goToPage(page: number) {
  if (page >= 1 && page <= totalPages.value) {
    currentPage.value = page;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[6] || (_cache[6] = _createStaticVNode("<div class=\"d-flex justify-content-between align-items-center flex-wrap gap-3 mb-1\"><h5 class=\"mb-0\">Upcoming VIP Reservations</h5><div class=\"dropdown select-dropdown\"><button class=\"dropdown-toggle border text-body rounded-2 bg-gray-100\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\"> Monthly </button><ul class=\"dropdown-menu dropdown-menu-end bg-white border-0 box-shadow py-3\"><li><button class=\"dropdown-item text-secondary py-2 px-3\"> Weekly </button></li><li><button class=\"dropdown-item text-secondary py-2 px-3\"> Monthly </button></li><li><button class=\"dropdown-item text-secondary py-2 px-3\"> Yearly </button></li></ul></div></div>", 1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("table", _hoisted_4, [
          _cache[3] || (_cache[3] = _createElementVNode("thead", null, [
            _createElementVNode("tr", { class: "border-bottom" }, [
              _createElementVNode("th", { class: "bg-transparent text-body fw-medium" }, [
                _createElementVNode("span", { class: "fs-10 fw-bold" }, "CODE")
              ]),
              _createElementVNode("th", { class: "bg-transparent text-body fw-medium" }, [
                _createElementVNode("span", { class: "fs-10 fw-bold" }, "ROOM")
              ]),
              _createElementVNode("th", { class: "bg-transparent text-body fw-medium" }, [
                _createElementVNode("span", { class: "fs-10 fw-bold" }, "CUSTOMER")
              ]),
              _createElementVNode("th", { class: "bg-transparent text-body fw-medium" }, [
                _createElementVNode("span", { class: "fs-10 fw-bold" }, "DURATION")
              ]),
              _createElementVNode("th", { class: "text-end bg-transparent text-body fw-medium" }, [
                _createElementVNode("span", { class: "fs-10 fw-bold opacity-0" }, "ACTION")
              ])
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedData.value, (reservation) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: reservation.code
              }, [
                _createElementVNode("td", _hoisted_5, _toDisplayString(reservation.code), 1),
                _createElementVNode("td", null, [
                  _createVNode(_component_RouterLink, {
                    to: "/hotel/room-details",
                    class: "fs-14 fw-semibold text-secondary"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(reservation.room), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _createElementVNode("td", _hoisted_6, _toDisplayString(reservation.customer), 1),
                _createElementVNode("td", null, [
                  _createElementVNode("span", _hoisted_7, _toDisplayString(reservation.duration), 1)
                ]),
                _cache[2] || (_cache[2] = _createElementVNode("td", { class: "text-end" }, [
                  _createElementVNode("div", { class: "d-flex justify-content-end align-items-center gap-2" }, [
                    _createElementVNode("button", { class: "ps-0 border-0 bg-transparent lh-1" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-primary" }, " visibility ")
                    ]),
                    _createElementVNode("button", { class: "ps-0 border-0 bg-transparent lh-1" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-primary-div-50" }, " edit ")
                    ]),
                    _createElementVNode("button", { class: "ps-0 border-0 bg-transparent lh-1" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-danger" }, " delete ")
                    ])
                  ])
                ], -1))
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("span", _hoisted_9, " Showing " + _toDisplayString(paginatedData.value.length) + " of " + _toDisplayString(reservations.value.length) + " Results ", 1),
        _createElementVNode("nav", _hoisted_10, [
          _createElementVNode("ul", _hoisted_11, [
            _createElementVNode("li", {
              class: _normalizeClass(["page-item", { disabled: currentPage.value === 1 }])
            }, [
              _createElementVNode("button", {
                class: "page-link icon hover-bg",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (goToPage(currentPage.value - 1)))
              }, [...(_cache[4] || (_cache[4] = [
                _createElementVNode("i", { class: "material-symbols-outlined" }, "keyboard_arrow_left", -1)
              ]))])
            ], 2),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(totalPages.value, (page) => {
              return (_openBlock(), _createElementBlock("li", {
                key: page,
                class: _normalizeClass(["page-item", { active: currentPage.value === page }])
              }, [
                _createElementVNode("button", {
                  class: "page-link",
                  onClick: ($event: any) => (goToPage(page))
                }, _toDisplayString(page), 9, _hoisted_12)
              ], 2))
            }), 128)),
            _createElementVNode("li", {
              class: _normalizeClass(["page-item", { disabled: currentPage.value === totalPages.value }])
            }, [
              _createElementVNode("button", {
                class: "page-link icon hover-bg",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (goToPage(currentPage.value + 1)))
              }, [...(_cache[5] || (_cache[5] = [
                _createElementVNode("i", { class: "material-symbols-outlined" }, "keyboard_arrow_right", -1)
              ]))])
            ], 2)
          ])
        ])
      ])
    ])
  ]))
}
}

})